import { render } from "./ShopPerformance.vue?vue&type=template&id=173a52a2"
import script from "./ShopPerformance.vue?vue&type=script&lang=js"
export * from "./ShopPerformance.vue?vue&type=script&lang=js"

import "./ShopPerformance.vue?vue&type=style&index=0&id=173a52a2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__